import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import FormLabel from '@material-ui/core/FormLabel';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import FieldFileDropzoneTable from './table';
import {
    combineUploadFileInfoWithApiFile,
    deleteFileRequest, getFilesInfoFromSprByFileIds,
    saveFilesRequest,
} from '@services/filemanager';
import FieldFileDropzone from './dropzone';
import {addNotification, loadingApplication} from '@componentDP/js_react/redux/actions/application';
import {filesInfoReceived} from '@componentDP/js_react/redux/actions/files';
import {FilemanagerApi} from '@requests';
import {withTranslation} from "react-i18next";

class FieldMultipleFile extends Component {
    constructor({name, scheme, refs, defaultValue: fileIds, filesSpr}) {
        super();
        this.state = {
            files: getFilesInfoFromSprByFileIds(fileIds, filesSpr),
            scheme,
            ids_for_delete: [],
        };
        refs[name] = this.accessCallbackToLocalState();
    }

    //Костыль, объект функций который помещается в ref массив сохранения
    //(1) values - для получения значений из локального состояния в action redux
    //(2) successSaved - callback-функция успешного сохранения, нужно чтобы перевести файлы локального состояния в
    //положение "зафиксирован сторонней системой", в этом случае эти файлы будут удаляться не сразу,
    //а после следующего успешного сохранения
    accessCallbackToLocalState = () => {
        return {
            values: () => this.upValues(),
            successSaved: () => this.successSaved(),
        };
    };

    componentDidUpdate (prevProps) {
        this.props.refs[prevProps.name] = this.accessCallbackToLocalState();
    }

    upValues = () => {
        const {ids_for_delete: idsForDelete, files} = this.state;
        return {
            ids_for_delete: idsForDelete,
            ids_for_send: files.map(({id}) => id),
        };
    };

    successSaved = () => {
        const state = this.state;
        const result = state.files.map(file => {
            return {...file, confirmed: true}
        });
        this.setState({...state, ids_for_delete: [], files: result});
    };

    onDrop = async (acceptedFiles) => {
        const { vuzId, apiDomainFilemanager, loadingApplication } = this.props;
        loadingApplication(true);
        const requestsPayload = await saveFilesRequest(acceptedFiles, vuzId, apiDomainFilemanager);
        const state = this.state;
        const files = [...state.files];
        const newApiFileSpr = [];
        requestsPayload.forEach(requestPayload => {
            const {result: requestResult, file} = requestPayload;
            if (!requestResult.hasOwnProperty('error')) {
                const formattedFileInfo = {
                    ...combineUploadFileInfoWithApiFile(requestResult, file),
                    confirmed: false,
                };
                files.push(formattedFileInfo);
                newApiFileSpr.push(requestResult);
            } else {
                const error = `Файл: ${file.name}:<br>${requestResult.error}`;
                this.props.addNotification({message: error, type: 'error'});
            }
        });
        if (!isEmpty(newApiFileSpr)) {
            this.props.filesInfoReceived(newApiFileSpr);
        }
        this.setState({...state, files});
        loadingApplication(false);
    };

    /* Файлы, которые уже были зафиксированы системой vikon, будут удалены только после подтвержения (успешного сохранения).
    Несохраненные(временные) файлы могут быть удалены сразу.
     */
    handleRemoveFile = async (removeFileId) => {
        const state = this.state;
        const {loadingApplication} = this.props;
        const {files} = state;
        const file = files.find(({id}) => id === removeFileId);
        if (file) {
            if (!file.confirmed) {
                loadingApplication(true);
                const {apiDomainFilemanager} = this.props;
                const deleteResult = await deleteFileRequest(removeFileId, apiDomainFilemanager);
                if (!deleteResult.hasOwnProperty('error')) {
                    const result = files.filter(({id}) => id !== removeFileId);
                    this.setState({...state, files: result});
                } else {
                    this.props.addNotification({message: deleteResult.error, type: 'error'});
                }
                loadingApplication(false);
            } else {
                const { ids_for_delete: idsForDelete } = state;
                const result = files.filter(({id}) => id !== removeFileId);
                idsForDelete.push(removeFileId);
                this.setState({...state, ids_for_delete: idsForDelete, files: result});
            }
        }
    };

    handleDownloadFile = async (fileId) => {
        const {apiDomainFilemanager} = this.props;
        const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
        await filemanagerApi.downloadFile(fileId);
    };

    render() {
        const {files, scheme} = this.state;

        const { i18n } = this.props;
        const currentLang = i18n.language;
        const filesTable = !isEmpty(files)
            ? <FieldFileDropzoneTable files={files}
                                      handleRemoveFile={this.handleRemoveFile} handleDownloadFile={this.handleDownloadFile} />
            : null;
        const label = scheme && scheme.label
            ? <FormLabel component="legend">
                {currentLang === 'en' ? scheme.label_en : scheme.label}
                {scheme.required === true ? <span className="MuiFormLabel-asterisk">*</span> : ''}
            </FormLabel>
            : null;
        return (
            <React.Fragment>
                {label}
                <FieldFileDropzone onDrop={this.onDrop}/>
                {filesTable}
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        vuzId: state.vuzId,
        filesSpr: state.files,
        apiDomainFilemanager: state.apiDomainFilemanager,
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    addNotification,
    loadingApplication,
    filesInfoReceived,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FieldMultipleFile));
